import type { ReactElement } from 'react';
import type { CsvAnalysis } from 'troppus-common/shared';

import { delimiterLabel, encodingLabel } from '../csvLabels';

type ConfigureCsvAnalysisSummarySectionProps = {
  analysis: CsvAnalysis;
};

export function ConfigureCsvAnalysisSummarySection({ analysis }: ConfigureCsvAnalysisSummarySectionProps): ReactElement {
  return (
    <section className="flex flex-col gap-4 admin-ui">
      <h2 className="text-sm font-semibold text-default">CSV 解析結果</h2>
      <ul className="text-sm text-muted-light">
        <li>文字コード: {encodingLabel(analysis.detectedEncoding)}</li>
        <li>区切り文字: {delimiterLabel(analysis.detectedDelimiter)}</li>
        <li>推定行数: {analysis.rowCountEstimate.toLocaleString()} 行程度</li>
        <li>ヘッダー行: {analysis.hasHeaderRow ? 'あり' : 'なし'}</li>
      </ul>
    </section>
  );
}
